import { baseBackendRoute } from "../config/generals";

const fmt = (d: Date): string =>
    `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export interface IBuildStatsUrlParams {
    demandPartnerId: string;
    clientKey: string;
    clientSecret: string;
}

export const buildStatsUrl = (p: IBuildStatsUrlParams): string => {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    const qs =
        `clientKey=${encodeURIComponent(p.clientKey)}` +
        `&startDate=${fmt(yesterday)}` +
        `&endDate=${fmt(today)}` +
        `&demandPartnerId=${encodeURIComponent(p.demandPartnerId)}` +
        `&breakdown=day` +
        `&clientSecret=${p.clientSecret}`;
    return `${baseBackendRoute}/api/stats?${qs}`;
};
